/*
 * @author: liqian
 * @date: Do not Edit
 * @description: 全局状态管理入口
 */
import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import publics from './modules/public'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        publics
    },
})



// WEBPACK FOOTER //
// ./src/store/index.js